export enum CampaignStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
